export default {"src":"/_next/static/media/verizon.f0abebce.svg","height":146,"width":658,"blurWidth":0,"blurHeight":0};